import Header from "./Header";
import About from "./About";
import Team from "./Team";
import Events from "./Events";
import FAQ from "./FAQ";
import Sponsors from './Sponsors';
import Schedule from "./Schedule";
import GuestSpeakers from "./GuestSpeakers";
import Footer from "./Footer";

const Home = () => {



  return (
    <>
      <Header />
      <About />
      <Team />
      <Events />
      <FAQ />
      <Schedule />
      <GuestSpeakers />
      <Sponsors />
      <Footer />
    </>
  )
}

export default Home;